// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__1BlpX","content":"styles_content__14EeU"};